"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ui_1 = require("./ui");

var list_super_1 = __importDefault(require("./list-super"));

var pagination_material_1 = __importDefault(require("./pagination-material")); // by default we use the pagination from Material UI


var Pagination = pagination_material_1.default; // PaginationSuper({ PaginationUnit, PaginationWrapper });

var List = function List(props) {
  return list_super_1.default({
    HeaderUnit: ui_1.HeaderUnit,
    FilterUnit: ui_1.FilterUnit,
    OrderController: ui_1.OrderController,
    ColCell: ui_1.ColCell,
    GlobalSearch: ui_1.GlobalSearch,
    NoRow: ui_1.NoRow,
    Row: ui_1.Row,
    ListWrapper: ui_1.ListWrapper,
    ListContainer: ui_1.ListContainer,
    ListHeader: ui_1.ListHeader,
    ListBody: ui_1.ListBody,
    RecordInfo: ui_1.RecordInfo,
    Pagination: Pagination
  })(props);
};

exports.default = List;